import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="online-count-pill"
export default class extends Controller {
  static targets = ["pill", "tooltipBody"]
  static values = {
    breakdownUrl: String,
    countUrl: String,
    i18nKey: String,
    oneLabel: String,
    otherLabel: String,
    pollMs: { type: Number, default: 30000 },
    zeroLabel: String,
  }

  connect() {
    this.breakdownLoaded = false
    this.hasFetchedCount = false
    this.hidePill()
    this.refreshCount()
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  async loadBreakdown() {
    if (this.breakdownLoaded || !this.hasBreakdownUrlValue || !this.hasTooltipBodyTarget) return

    try {
      const response = await fetch(this.breakdownUrlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
      if (!response.ok) return

      const payload = await response.json()
      this.tooltipBodyTarget.innerHTML = payload.html
      this.breakdownLoaded = true
    } catch {
      // no-op, keep loading text
    }
  }

  async refreshCount() {
    if (!this.hasCountUrlValue) return

    try {
      const response = await fetch(this.countUrlValue, {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
      if (!response.ok) return

      const payload = await response.json()
      this.updatePillText(payload.count)
      this.showPill()
      this.hasFetchedCount = true
    } catch {
      if (!this.hasFetchedCount) {
        this.hidePill()
      }
    }
  }

  startPolling() {
    this.pollTimer = setInterval(() => {
      this.refreshCount()
    }, this.pollMsValue)
  }

  stopPolling() {
    if (!this.pollTimer) return

    clearInterval(this.pollTimer)
    this.pollTimer = null
  }

  updatePillText(count) {
    const text = this.translateCount(count)
    const innerPill = this.pillTarget.querySelector("span")

    if (innerPill) {
      innerPill.textContent = text
    } else {
      this.pillTarget.textContent = text
    }
  }

  hidePill() {
    this.pillTarget.classList.add("invisible")
  }

  showPill() {
    this.pillTarget.classList.remove("invisible")
  }

  translateCount(count) {
    if (window.I18n && this.hasI18nKeyValue) {
      return window.I18n.t(this.i18nKeyValue, { count: count })
    }

    if (count === 0 && this.hasZeroLabelValue) {
      return this.zeroLabelValue
    }

    if (count === 1 && this.hasOneLabelValue) {
      return this.oneLabelValue
    }

    if (this.hasOtherLabelValue) {
      return this.otherLabelValue.replace("%{count}", count)
    }

    return `${count}`
  }
}
